import { jsx } from 'react/jsx-runtime';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './button.js';
import '../../contexts/AppContext.js';
import 'lucide-react';
import 'react';
import '../../lib/toast.js';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'react-day-picker';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import './radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function Progress({ className, value, ...props }) {
    return (jsx(ProgressPrimitive.Root, { "data-slot": "progress", className: cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className), ...props, children: jsx(ProgressPrimitive.Indicator, { "data-slot": "progress-indicator", className: "bg-primary h-full w-full flex-1 transition-all", style: { transform: `translateX(-${100 - (value || 0)}%)` } }) }));
}

export { Progress };
//# sourceMappingURL=progress.js.map
